<div class="staff-payroll-component-container page-root-container">
    <div class="page-header">
        <div class="page-title">
            <img class="icon" src="assets/images/menu/svg/staff-payroll.svg">
            <span class="title">Staff Payroll Group</span>
        </div>
        <div class="page-actions">
            <!-- <button mat-button color="primary" class="btn-add" (click)="onEdit(null)">
        <mat-icon>person_add</mat-icon>New
      </button> -->
        </div>
    </div>

    <div class="data-container">
        <form [formGroup]="filterForm" style="display: flex; gap: 0.5rem; margin-bottom: 1rem; align-items: center;">
            <!-- Payroll Group Autocomplete -->
            <mat-form-field appearance="fill" class="filter-dropdown" style="min-width: 120px; max-width: 150px;">
                <mat-label>Payroll Group</mat-label>
                <!-- <input #payrollGroupInput type="text" matInput [matAutocomplete]="payrollGroupAuto"
                    formControlName="payroll_group_id"
                    [value]="getPayrollGroupName(filterForm.value.payroll_group_id)"
                    (input)="filterPayrollGroups(payrollGroupInput.value)"> -->
                <input #payrollGroupInput type="text" matInput [matAutocomplete]="payrollGroupAuto"
                    formControlName="payroll_code" (input)="filterPayrollGroups(payrollGroupInput.value)">
                <button *ngIf="filterForm.value.payroll_code" matSuffix mat-icon-button aria-label="Clear"
                    (click)="clearPayrollGroup()">
                    <mat-icon>close</mat-icon>
                </button>
                <!-- <mat-autocomplete #payrollGroupAuto="matAutocomplete"
                    (optionSelected)="selectPayrollGroup($event.option.value)">
                    <mat-option *ngFor="let group of filteredPayrollGroups" [value]="group.id">
                        {{ group.code }}
                    </mat-option>
                </mat-autocomplete> -->
                <mat-autocomplete #payrollGroupAuto="matAutocomplete" [displayWith]="displayPayrollGroup"
                    (optionSelected)="selectPayrollGroup($event.option.value)">
                    <mat-option *ngFor="let group of filteredPayrollGroups" [value]="group.code">
                        {{ group.code }}
                    </mat-option>
                </mat-autocomplete>
                <mat-error
                    *ngIf="filterForm.controls['payroll_code'].hasError('required') && filterForm.controls['payroll_code'].touched">
                    Payroll Group is required
                </mat-error>
            </mat-form-field>

            <!-- <mat-error *ngIf="filterForm.controls['payroll_code'].hasError('required')">Payroll Code should be
                                        entered</mat-error> -->

            <!-- Shop Payroll Autocomplete -->
            <!-- <mat-form-field appearance="fill" class="filter-dropdown" style="min-width: 220px; max-width: 300px;">
                <mat-label>Shop</mat-label>
                <input #shopPayrollInput type="text" matInput [matAutocomplete]="shopPayrollAuto" formControlName="shop_id"
                    [value]="getShopName(filterForm.value.shop_id)" 
                    (input)="filterShopPayrolls(shopPayrollInput.value)"
                    [disabled]="!filterForm.value.payroll_group_id">
                <button *ngIf="filterForm.value.shop_id" matSuffix mat-icon-button aria-label="Clear"
                    (click)="clearShopPayroll()">
                    <mat-icon>close</mat-icon>
                </button>
                <mat-autocomplete #shopPayrollAuto="matAutocomplete"
                    (optionSelected)="selectShopPayroll($event.option.value)">
                    <mat-option *ngFor="let shop of filteredShopPayrolls" [value]="shop.shop_id">
                        {{ shop.name }}
                    </mat-option>
                </mat-autocomplete>
            </mat-form-field> -->
            <mat-form-field appearance="fill" class="filter-dropdown" style="min-width: 220px; max-width: 300px;">
                <mat-label>Shop</mat-label>

                <input #shopPayrollInput type="text" matInput [matAutocomplete]="shopPayrollAuto"
                    formControlName="shop_id" (input)="filterShopPayrolls(shopPayrollInput.value)"
                    [disabled]="!filterForm.value.payroll_code">

                <button *ngIf="filterForm.value.shop_id" matSuffix mat-icon-button aria-label="Clear"
                    (click)="clearShopPayroll()">
                    <mat-icon>close</mat-icon>
                </button>

                <mat-autocomplete #shopPayrollAuto="matAutocomplete" [displayWith]="displayShopName"
                    (optionSelected)="selectShopPayroll($event.option.value)">

                    <mat-option *ngFor="let shop of filteredShopPayrolls" [value]="shop">
                        {{ shop.name }}
                    </mat-option>

                </mat-autocomplete>
                <mat-error
                    *ngIf="filterForm.controls['shop_id'].hasError('required') && filterForm.controls['shop_id'].touched">
                    Shop is required
                </mat-error>
            </mat-form-field>

            <!-- Validation message -->
            <span *ngIf="showValidation" style="color: red; font-size: 12px;">Please select payroll first</span>

            <!-- Status Dropdown -->
            <mat-form-field appearance="fill" class="filter-dropdown" style="min-width: 90px; max-width: 110px;">
                <mat-label>Status</mat-label>
                <mat-select formControlName="status">
                    <mat-option *ngFor="let s of statusList" [value]="s.value">{{ s.label }}</mat-option>
                </mat-select>
            </mat-form-field>

            <!-- Search Button -->
            <button mat-raised-button color="primary" style="min-width: 80px; max-width: 100px;" (click)="loadList()">
                Search
            </button>

            <!-- Search Filter -->
            <!-- <div class="search-filter-container" style="min-width:90px; width:60%;">
                <app-search-filter #searchFilter [pagingData]="pagingData" [pageSizeOptions]="[5,10,20,50,100]"
                    [filter]="filter" (page)="onePageEvent($event)" (onApply)="onFilterApplied($event)"
                    [hidePageSize]="true" [hideAdvancedFilter]="true">
                </app-search-filter>
            </div> -->
        </form>

        <app-loader [show]="isLoading"></app-loader>

        <section tabindex="0" class="table-container">
            <table matSort mat-table [dataSource]="dataSource">
                <ng-container matColumnDef="sl">
                    <th mat-header-cell *matHeaderCellDef>#</th>
                    <td mat-cell *matCellDef="let row; let i = index">{{ (pagingData.pageIndex * pagingData.pageSize) +
                        i + 1 }}</td>
                </ng-container>
                <ng-container matColumnDef="code">
                    <th mat-header-cell *matHeaderCellDef>Code</th>
                    <td mat-cell *matCellDef="let row">{{ row.code }}</td>
                </ng-container>
                <ng-container matColumnDef="name">
                    <th mat-header-cell *matHeaderCellDef>Name</th>
                    <td mat-cell *matCellDef="let row">{{ row.name }}</td>
                </ng-container>
                <ng-container matColumnDef="fixed_pay">
                    <th mat-header-cell *matHeaderCellDef>Fixed Pay</th>
                    <td mat-cell *matCellDef="let row">{{ row.fixed_pay }}</td>
                </ng-container>
                <ng-container matColumnDef="payroll_code">
                    <th mat-header-cell *matHeaderCellDef>Payroll Code</th>
                    <td mat-cell *matCellDef="let row">{{ row.payroll_code }}</td>
                </ng-container>
                <ng-container matColumnDef="action">
                    <th mat-header-cell *matHeaderCellDef>Action</th>
                    <td mat-cell *matCellDef="let row">
                        <button mat-icon-button color="primary" (click)="onEdit(row)">
                            <mat-icon>edit</mat-icon>
                        </button>
                    </td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            </table>
            <div *ngIf="dataSource.data.length === 0 && !isLoading" class="no-data-container">
                <img src="assets/images/no-data.png">
                <span class="no-data-info">No data found. Please remove or redefine the filters if any.</span>
            </div>
        </section>
    </div>
</div>